import type { RouteObject } from 'react-router-dom';
import RequireAuth from '@/components/feature/RequireAuth';
import NotFound from '@/pages/NotFound';
import HomePage from '@/pages/home/page';
import AgentPage from '@/pages/agent/page';
import AgentDetailPage from '@/pages/agent/detail';
import DecisionsPage from '@/pages/agent/decisions';
import AssetsPage from '@/pages/assets/page';
import ProfilePage from '@/pages/profile/page';
import AuthPage from '@/pages/auth/page';
import ExternalAuthReturnPage from '@/pages/auth/ExternalAuthReturnPage';
import BacktestPage from '@/pages/backtest/page';
import BrokerBindPage from '@/pages/broker/page';
import NotificationsPage from '@/pages/notifications/page';
import SecurityPage from '@/pages/security/page';
import RiskPreferencePage from '@/pages/risk-preference/page';
import SplashPage from '@/pages/splash/page';
import MarketPage from '@/pages/market/page';
import CopyConfigPage from '@/pages/copy-config/page';
import TradeHistoryPage from '@/pages/trade-history/page';
import ProfitStatsPage from '@/pages/profit-stats/page';
import HistoryPage from '@/pages/history/page';
import ExecutionLogPage from '@/pages/execution-log/page';

const routes: RouteObject[] = [
  // ── Splash ──
  {
    path: '/splash',
    element: <SplashPage />,
  },

  // ── Public ──
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/auth',
    element: <AuthPage />,
  },
  {
    path: '/auth/external/return/:provider',
    element: <ExternalAuthReturnPage />,
  },
  {
    path: '/auth/native/return/:provider',
    element: <ExternalAuthReturnPage />,
  },

  // ── Bottom Tab 2: 智能体跟单中心 ──
  {
    path: '/agent',
    element: <AgentPage />,
  },
  {
    path: '/agent/:id',
    element: <RequireAuth><AgentDetailPage /></RequireAuth>,
  },

  {path: '/ai-decisions', element: <RequireAuth><DecisionsPage /></RequireAuth>},
  {path: '/ai-decisions/:id', element: <RequireAuth><DecisionsPage /></RequireAuth>},

  // ── Bottom Tab 3: 收益 ──
  {
    path: '/assets',
    element: <AssetsPage />,
  },

  // ── Bottom Tab 4: 我的 ──
  {
    path: '/profile',
    element: <RequireAuth><ProfilePage /></RequireAuth>,
  },

  // ── 跟单配置 ──
  {
    path: '/copy-config',
    element: <RequireAuth><CopyConfigPage /></RequireAuth>,
  },

  // ── 历史交易记录 ──
  {
    path: '/trade-history',
    element: <RequireAuth><TradeHistoryPage /></RequireAuth>,
  },

  // ── 子页面（从我的页进入）──
  {
    path: '/broker',
    element: <RequireAuth><BrokerBindPage /></RequireAuth>,
  },
  {
    path: '/security',
    element: <RequireAuth><SecurityPage /></RequireAuth>,
  },
  {
    path: '/risk-preference',
    element: <RequireAuth><RiskPreferencePage /></RequireAuth>,
  },
  {
    path: '/notifications',
    element: <RequireAuth><NotificationsPage /></RequireAuth>,
  },

  // ── 其他保留页面（隐藏入口）──
  {
    path: '/market',
    element: <RequireAuth><MarketPage /></RequireAuth>,
  },
  {
    path: '/backtest',
    element: <RequireAuth><BacktestPage /></RequireAuth>,
  },

  // ── 收益统计详情 ──
  {
    path: '/profit-stats',
    element: <RequireAuth><ProfitStatsPage /></RequireAuth>,
  },

  // ── 历史交易记录 ──
  {
    path: '/history',
    element: <RequireAuth><HistoryPage /></RequireAuth>,
  },

  // ── 决策日志 ──
  {
    path: '/execution-log',
    element: <RequireAuth><ExecutionLogPage /></RequireAuth>,
  },

  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
